import { render, staticRenderFns } from "./AppliedFiltersSummary.vue?vue&type=template&id=6f60a765&"
import script from "./AppliedFiltersSummary.vue?vue&type=script&lang=js&"
export * from "./AppliedFiltersSummary.vue?vue&type=script&lang=js&"
import style0 from "./AppliedFiltersSummary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports